// Func = limiting Scope for this file
var lastScrollTop = 0;
let speed = 0;
let stopAnimation = false;
let currentSeason = localStorage.getItem( "season" ) ? localStorage.getItem( "season" ) : "summer";

//device size
let documentHeight = Math.max(
	document.body.scrollHeight,
	document.documentElement.scrollHeight,
	document.body.offsetHeight,
	document.documentElement.offsetHeight,
	document.body.clientHeight,
	document.documentElement.clientHeight
);
let viewportWidth = window.innerWidth;

function changeSeason( season ){
	
	currentSeason = season;
	localStorage.setItem( "season", season );
	document.querySelector( "body" ).classList.remove( "winter-theme" );
	document.querySelector( "body" ).classList.remove( "summer-theme" );
	document.querySelector( "body" ).classList.add( season + "-theme" );

	//amenities quad change.
	if(document.querySelector('#amenitiesContainer')){
		let AMENITIES_CONTAINER = document.querySelector('#amenitiesContainer');
		let seasonAmenities = season == "summer" ? AMENITIES_CONTAINER.dataset.summer : AMENITIES_CONTAINER.dataset.winter ;
		fetch(`/ajax/functions.php?operation=getAmenities&amenities=${seasonAmenities}`,{method: "GET"})
                .then((resp) => resp.json()) // Transform the data into json
                .then((data) => {
                    AMENITIES_CONTAINER.innerHTML = data.html;
                }).then((data) => {

				});
	}
	if(document.querySelector('#amenitiesContent')){
		let AMENITIES_CONTAINER = document.querySelector('#amenitiesContent');
		let seasonAmenities = season == "summer" ? AMENITIES_CONTAINER.dataset.summer : AMENITIES_CONTAINER.dataset.winter ;
		fetch(`/ajax/functions.php?operation=getSimpleAmenities&amenities=${seasonAmenities}`,{method: "GET"})
                .then((resp) => resp.json()) // Transform the data into json
                .then((data) => {
                    AMENITIES_CONTAINER.innerHTML = data.html;
                }).then((data) => {

				});
	}
	if(document.querySelectorAll('.js-season-src').length > 0){
		document.querySelectorAll('.js-season-src').forEach(image => {
			image.src = image.dataset[season]; 
		});
	}
	//Gallery Page
	if(document.querySelectorAll('.gallery-flex__image').length > 0){
		document.querySelectorAll('.gallery-flex__image').forEach(image => {
			if(image.dataset.filter == season){
				image.classList.remove('hidden');

			} else {	
				image.classList.add('hidden');
			}
		});
	}
	//season image change
	if(document.querySelectorAll('.js-season-img').length > 0){
		document.querySelectorAll('.js-season-img').forEach(image => {
			image.src = image.dataset[season];
		})
	}
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	/* Change of season */
	let toggle_season = document.querySelector('#toggle-season');
	let visit_content = document.querySelector('.visit-content');
	if(toggle_season){
		changeSeason( currentSeason );
		if(currentSeason == "summer"){
			toggle_season.checked = true;
			visit_content.querySelector('.season-winter').classList.remove('true');
			visit_content.querySelector('.season-summer').classList.add('true');
		}
		toggle_season.addEventListener( "change", (e) => {
			let value = e.target.checked;
			if(value){
				changeSeason( "summer" );
				visit_content.querySelector('.season-winter').classList.remove('true');
				visit_content.querySelector('.season-summer').classList.add('true');
			}
			else {
				changeSeason( "winter" );
				visit_content.querySelector('.season-winter').classList.add('true');
				visit_content.querySelector('.season-summer').classList.remove('true');
			}
		});
	}

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		OBSERVER TO ADD PARALLAX EFFECT
		*****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		END OF OBSERVER TO ADD PARALLAX EFFECT
		***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	/* Menu Site */
	let Body = document.body;

	document.addEventListener('DOMContentLoaded', () => {


		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		window.scrollTo(0, 0);
	

		/* Main Nav Dropdown */
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				if(primary_nav.querySelector('ul.submenu')){
					primary_nav.querySelector('a').classList.add('has-submenu');
				}
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		// pressforminquirypressform-form

		if(document.querySelector('#pressforminquirypressform-form')){
			let pressForm = document.querySelector("#pressforminquirypressform-form");
			pressForm.classList.add('opacity');
			setTimeout(() => {
				pressForm.classList.add('hidden');
			}, 500);
			let closeBtn = document.createElement('a');
			closeBtn.classList.add('close-btn');
			closeBtn.classList.add('js-close-btn');
			closeBtn.innerHTML = '<span>Close</span>';
			pressForm.insertBefore(closeBtn, pressForm.firstElementChild);


	
			let btnForm = document.querySelector(".press .btn-form");
			if(pressForm){
				btnForm.addEventListener('click', function(e){
					e.preventDefault();
					if(pressForm.classList.contains("hidden")){
						pressForm.classList.remove("hidden");
					} 
					pressForm.classList.remove('opacity');
				});
				
			}


			closeBtn.addEventListener('click', function(e){
				e.preventDefault();
				pressForm.classList.add('hidden');
			});

		}

		//slider animated text
		if(document.querySelector('.js-animate-text')){
			document.querySelectorAll('.js-animate-text').forEach(element => {
				let offset = 0;
				function animate() {
					offset -= 1; // Speed control
					if (Math.abs(offset) >= (element.scrollWidth / 1.6)) {
						offset = 0; // Reset seamlessly
					}
					element.style.transform = `translateX(${offset}px)`;
					requestAnimationFrame(animate);
				}

				animate();
			});
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		const jsLbxFloorPlan = new LBX('.js-lbx-floorplan', {
			customClass:'lbx-floorplan',
		});

		const jsLbxReadMore = new LBX('.js-lbx-readmore', {
			customClass:'lbx-readmore',
		});

		/* Lightbox Gallerys */
		const defaultLightbox = new LBX('.js-lbx-default', {
			beforeShow: function () {
				let lightboxSliders = document.querySelectorAll('.images-l-sliders');
				if(lightboxSliders){
					lightboxSliders.forEach(()=>{
						new Swiper('.images-l-sliders', {
							rewind: true,
							effect: "fade",
							fadeEffect: {
								"crossFade": true
							},
							navigation: {
								nextEl: ".sw-but-img-next",
								prevEl: ".sw-but-img-prev",
							},
						});
					});
				}
			},
		});

	});

	window.addEventListener("load", function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
	});

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	/* Scroll Intro*/
	let ScrollDown = document.getElementsByClassName('js-scrolldown');
	if(ScrollDown.length > 0){
		ScrollDown[0].addEventListener('click', function(){
			animateto('intro');
		});
	}

	/* FAQ */
	let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

	/*MOBILE MENU NAV
    ****************************************************************/

	let Html = document.getElementsByTagName('html')[0];
	let MenuBtn = document.getElementById('menu-btn');
	let CloseMenu = document.querySelectorAll('.close-menu');
	let Navigation = document.querySelectorAll('.navigation');
	let NavUl = document.querySelectorAll('.navigation .inner ul li');
	let NavA = document.querySelectorAll('.navigation .inner ul li a');
	let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

	/* Open Navigation */
	if(MenuBtn){
		MenuBtn.addEventListener('click', function(e){
			Html.classList.add('hide-overflow');
			Navigation[0].classList.add('open');
			NavUl.forEach(function(inner) {
				if(inner.classList.contains('item-open')){
					inner.scrollIntoView(false);
				}
			});
		});

		/* Sub-Navigation */
		/* Open active sub-nav on load */
		NavActive.forEach(function(inner) {
			inner.closest('.inner').classList.add('open');
			inner.parentNode.parentNode.parentNode.parentNode.classList.add('li-open');
			inner.closest('.sub-sub-menu').classList.add('menu-open');
		});

		/* Toggle open/close on tap */
		NavA.forEach(function(entry) {
			if(entry.nextElementSibling){
				entry.classList.add('link-parent');
				let clientChildren = entry.nextElementSibling.querySelector('.submenu');
				if(clientChildren != null){
					let clientHeight = clientChildren.clientHeight;
					if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
						entry.nextElementSibling.classList.add('menu-open');
						entry.nextElementSibling.style.height = clientHeight+'px';
						entry.classList.add('hover-open');
						entry.parentNode.classList.add('li-open');
					}
					entry.addEventListener('click', function(e){
						e.preventDefault();
						if(this.nextElementSibling.classList.contains('menu-open')){
							this.nextElementSibling.classList.remove('menu-open');
							this.nextElementSibling.style.height = '0px';
							this.classList.remove('hover-open');
							this.parentNode.classList.remove('li-open');
						} else {
							NavUl.forEach(function(ul) {
								if(ul.querySelector('.sub-sub-menu')){
									if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
										ul.querySelector('.sub-sub-menu').style.height = '0px';
										ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
										ul.querySelector('.link-parent').classList.remove('hover-open');
										ul.querySelector('.link-parent').parentNode.classList.remove('li-open');
									}
								}
							});
							this.nextElementSibling.classList.add('menu-open');
							this.nextElementSibling.style.height = clientHeight+'px';
							this.classList.add('hover-open');
							this.parentNode.classList.add('li-open');
						}
					});
				}
			}
		});
	}

	/* Close Navigation */
	if(CloseMenu[0]){
		CloseMenu[0].addEventListener('click', function(e){
			Html.classList.remove('hide-overflow');
			Navigation[0].classList.remove('open');
		});
	}

	let notCharge = document.querySelectorAll('.not-charge');
	if (notCharge){
		notCharge.forEach(entry => {
			entry.addEventListener('click', function(event){
				event.preventDefault();
			});
		});
	}

	let screenHeight = document.documentElement.clientHeight;
	let homeTopImg = document.getElementById('home');
	if(homeTopImg){
		homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
			if(screen.width < 600){
				entry.style.height = screenHeight-65+'px';
			} else {
				entry.style.height = screenHeight-40+'px';
			}
		});
		window.addEventListener("resize", function(){
			screenHeight = document.documentElement.clientHeight;
			homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
				if(screen.width < 600){
					entry.style.height = screenHeight-65+'px';
				} else {
					entry.style.height = screenHeight-40+'px';
				}
			});
			documentHeight = Math.max(
				document.body.scrollHeight,
				document.documentElement.scrollHeight,
				document.body.offsetHeight,
				document.documentElement.offsetHeight,
				document.body.clientHeight,
				document.documentElement.clientHeight
			);
			viewportWidth = window.innerWidth;
		});
	}

	

	/* Anchor Animation */
	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-lbx], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default, .link-parent))");
	if(aHref){
		aHref.forEach(function(a_href) {
			a_href.addEventListener('click', function(e){
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	}

	

	/* Animation icon home */
	let path = document.getElementById('animate_winter');
	if(path && window.innerWidth > 600){
		let currentX = 0;
		function onScroll() {
			let scrollY = window.scrollY;
			let maxScroll = 300;
			let direction = scrollY > lastScrollTop ? 1 : -1;
			if(direction == -1){
				path.parentElement.classList.add('up')
			} else {
				path.parentElement.classList.remove('up')
			}
			if (scrollY > maxScroll) {
				path.classList.add("stop");
			} else {
				path.classList.remove("stop");
			}
			// Clamp scrollY between 0 and maxScroll
			let clampedScroll = Math.max(0, Math.min(scrollY, maxScroll));
			let scrollRatio = clampedScroll / maxScroll;

			let maxTranslateX = 250; //half of the width

			let newX = scrollRatio * maxTranslateX;

			path.style.transform = `translateX(${newX}px)`;
			currentX = newX;
		}
		window.addEventListener("scroll", onScroll);
	}

	let path_s = document.getElementById('animate_summer');
	if(path_s && window.innerWidth > 600){
		let currentS = 0;
		function onScrollS() {
			let scrollY = window.scrollY;
			let maxScroll = '';
			if(screen.width < 1040){
				maxScroll = 268;
			} else {
				maxScroll = 300;
			}
			let direction = scrollY > lastScrollTop ? 1 : -1;
			if(direction == -1){
				path_s.parentElement.classList.add('up')
			} else {
				path_s.parentElement.classList.remove('up')
			}
			if (scrollY > maxScroll) {
				path_s.classList.add("stop");
			} else {
				path_s.classList.remove("stop");
			}
			// Clamp scrollY between 0 and maxScroll
			let clampedScroll = Math.max(0, Math.min(scrollY, maxScroll));
			let scrollRatio = clampedScroll / maxScroll;

			let maxTranslateX = '';
			if(screen.width < 1300){ //half of the width
				if(screen.width < 1040){
					maxTranslateX = 10;
				} else {
					maxTranslateX = 60;
				}
			} else {
				maxTranslateX = 160;
			}
			let newX = scrollRatio * maxTranslateX;
			path_s.style.transform = `translateX(-${newX}px)`;
			currentS = newX;
		}
		window.addEventListener("scroll", onScrollS);
	}

})();

function animateto(target){
	var gotoTarget = offset(document.getElementById(target)).top - 160;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	/* Time Interval */
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	/* check scroll down or up for header styles */
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	let subMenu = document.getElementById('subMenu');
	if(st > 80){
		if (st > lastScrollTop){
			/* downscroll code */
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
				if(subMenu){
					subMenu.classList.add('down');
					subMenu.classList.remove('up');
				}
			}
		} else {
			/* upscroll code */
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
				if(subMenu){
					subMenu.classList.add('up');
					subMenu.classList.remove('down');
				}
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')){
			header.classList.remove('up');
			header.classList.remove('down');
			if(subMenu){
				subMenu.classList.remove('up');
				subMenu.classList.remove('down');
			}
		}
	}

	let SubMenu = document.getElementById('subMenuAnchor');
	if(SubMenu){
		let subPost = document.getElementById('subMenu');
		let subPosition = '';
		if(document.body.classList.contains('alert_open')){
			subPosition = offset(SubMenu).top - 156;
		} else {
			if(screen.width < 600){
				subPosition = offset(SubMenu).top - 70;
			} else {
				subPosition = offset(SubMenu).top - 96;
			}
		}
		if(st > subPosition){
			if(!subPost.classList.contains('floating-up')){
				subPost.classList.add('floating-up');
			}
		} else {
			if(subPost.classList.contains('floating-up')) {
				subPost.classList.remove('floating-up');
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

}